import { render, staticRenderFns } from "./RecognitionCard.vue?vue&type=template&id=1e76f949"
import script from "./RecognitionCard.vue?vue&type=script&lang=js"
export * from "./RecognitionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports